import styled from 'styled-components';
import { motion } from 'framer-motion6';
import { sizes } from 'style';
import { ReactComponent as CurveImg } from 'products/global/assets/img/join-us/benefits-curve.svg';

export const HeroBackground = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.black};
`;

export const HeroContainer = styled.div`
  position: relative;
  max-width: 1440px;
  margin: 0 auto;
  padding-bottom: 110px;

  @media ${sizes.tabletLandscape} {
    padding-top: ${({ paddingTop }) => `${paddingTop}px`};
  }
`;

export const Curve = styled(CurveImg)`
  position: absolute;
  margin-top: -1px;
  width: 100%;
  color: ${({ theme }) => theme.colors.black};
`;

export const Globe = styled(motion.img)`
  user-select: none;
  -webkit-user-drag: none;
  position: relative;
  display: block;
  border-radius: 50%;
  width: 80%;
  max-width: 400px;
  margin: 0 auto;
  margin-top: 40px;

  @media ${sizes.tabletLandscape} {
    width: 50%;
    max-width: 640px;
    position: absolute;
    margin-top: 0;
    padding-bottom: 0;
    margin-left: 2%;
    top: calc(50vh - 25vw);
  }

  @media (min-width: 1280px) {
    top: calc(50vh - 320px);
  }

  @media ${sizes.extraLargeDesktop} {
    margin-left: 80px;
  }
`;
